export default function PageTitle({ children, as: Tag = "h1", className = "" }) {
  return (
    <Tag className={`text-4xl font-bebas tracking-wide uppercase mb-6 ${className}`}>
      {children}
    </Tag>
  );
}
